export function userDeleteForm() {
    Alpine.data('userDelete', () => ({
        want_to_delete_user: false,
        user_data_resetted: false,

        trigger_prompt: {
            ["@click"](e) {
                this.want_to_delete_user = true;
            }
        },

        show_modal: {
            ["x-show"]() {
                return this.want_to_delete_user
            },
            ["x-on:keydown.escape.prevent.stop"]() {
                this.want_to_delete_user = false;
            }
        },

        show_overlay : {
            ["x-show"]() {
                return this.want_to_delete_user
            }
        },

        show_panel : {
            ["x-show"]() {
                return this.want_to_delete_user
            }
        },

        clear_user_data() {
            let formData = new FormData(this.$refs.clear_user_data_form);
            formData.append('action', 'mh_reset_user_data')

            fetch(site_objects.ajax_url, {
                method: "POST",
                body: formData
            })
                .then((res) => res.json())
                .then((res) => {
                    if(!res.success) return;

                    this.user_data_resetted = true
                })
        }
    }))
}